import * as React from "react";
export default class MapMarker extends React.Component {
    constructor(props) {
        super(props);
        this.toggleInfo = () => {
            this.setState({ toggle: !this.state.toggle });
        };
        this.state = {
            toggle: false
        };
    }
    render() {
        const infoWindow = this.state.toggle ?
            React.createElement("div", { className: "info-window", onClick: this.toggleInfo }, this.props.infoContent ?
                this.props.infoContent :
                null) : null;
        return (React.createElement("div", { className: "marker-container" },
            infoWindow,
            React.createElement("div", { className: "marker", onClick: this.toggleInfo },
                React.createElement("img", { role: "presentation", src: !this.state.toggle ? "/img/map-pin-blue.png" : "/img/map-pin-purple.png" }))));
    }
}
;
//# sourceMappingURL=map-marker.js.map